import styled from 'styled-components';

const CourseName = styled.h5`
  color: #4a6cbb;
  font-size: 16px;
  font-weight: 300;
`;

export default CourseName;
